export default "__VITE_ASSET__9097f65e__"